
import 'firebase/analytics';
import * as firebase from 'firebase/app';
import TagManager from 'react-gtm-module';
import ReactPixel from 'react-facebook-pixel';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_TRACKING_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_TRACKING_FIREBASE_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_TRACKING_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_TRACKING_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_TRACKING_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_TRACKING_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_TRACKING_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_TRACKING_FIREBASE_MEASUREEMENT_ID,
};
firebase.initializeApp(firebaseConfig);
const firebaseAnalytics = firebase.analytics();

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_TRACKING_GTM_ID
};
TagManager.initialize(tagManagerArgs);

ReactPixel.init(process.env.REACT_APP_TRACKING_FACEBOOK_PIXEL_ID);

export default firebaseAnalytics;
